module.exports = __webpack_public_path__ + "img/passport-wrong-dark.98631252.png";